import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_main_menu = _resolveComponent("main-menu")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { id: "main-content" }, {
    default: _withCtx(() => [
      ($setup.currentPath !== '/calculator')
        ? (_openBlock(), _createBlock(_component_main_menu, {
            key: 0,
            imgSrc: $setup.imageForHeader,
            pageTitle: $setup.textForHeader,
            currentRoute: $setup.currentPath
          }, null, 8, ["imgSrc", "pageTitle", "currentRoute"]))
        : _createCommentVNode("", true),
      _createVNode(_component_ion_content, {
        fullscreen: false,
        class: _normalizeClass(["base-content", $setup.directionClass])
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]),
        _: 3
      }, 8, ["class"])
    ]),
    _: 3
  }))
}